import { FormattedDate, FormattedMessage } from 'react-intl';

interface Props {
  at: string | null;
}

export default function FormattedAppointment({ at }: Props) {
  if (!at) {
    return <FormattedMessage id="common.notSet" />;
  }

  return (
    <FormattedDate
      value={new Date(at)}
      year="numeric"
      month="2-digit"
      day="2-digit"
      hour="2-digit"
      minute="2-digit"
    />
  );
}
